
<div class="login-page">
  <!-- 1920px 设计版心 -->
  <main class="login-canvas">
    <!-- 页面背景层：第二张图片 -->
    <div class="login-background" aria-hidden="true"></div>

    <!-- 左侧科技图形：第一张图片 -->
    <div class="login-visual" aria-hidden="true">
      <div class="visual-glow"></div>
      <div class="visual-art"></div>
    </div>

    <!-- 右侧登录表单 -->
    <section class="login-panel">
      <div class="login-content">
        <h1 class="login-title">{{ systemName }}</h1>

        <a-form
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >
          <!-- 用户名 -->
          <a-form-item class="login-field-item">
            <label class="login-label">用户名</label>

            <div class="login-input-wrap">
              <a-icon type="user" class="login-input-icon" />

              <a-input
                v-decorator="[
                  'username',
                  {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        whitespace: true,
                        message: '请输入用户名',
                      },
                    ],
                  },
                ]"
                class="login-input"
                placeholder="请输入用户名"
                autocomplete="username"
                size="large"
                allow-clear
              />
            </div>
          </a-form-item>

          <!-- 密码 -->
          <a-form-item class="login-field-item">
            <label class="login-label">密码</label>

            <div class="login-input-wrap">
              <a-icon type="lock" class="login-input-icon" />

              <a-input-password
                v-decorator="[
                  'password',
                  {
                    initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: '请输入密码',
                      },
                    ],
                  },
                ]"
                class="login-input"
                placeholder="请输入密码"
                autocomplete="current-password"
                size="large"
              />
            </div>
          </a-form-item>

          <!-- 登录按钮 -->
          <a-form-item class="login-submit-item">
            <a-button
              type="primary"
              html-type="submit"
              class="login-submit-btn"
              :loading="loading"
              block
            >
              <span>登录</span>
              <a-icon type="arrow-right" class="submit-arrow" />
            </a-button>
          </a-form-item>
        </a-form>

        <div class="login-security-tip">
          <a-icon type="safety-certificate" />
          <span>安全登录 · 高效管理</span>
        </div>
      </div>
    </section>
  </main>
</div>
